<template>
  <div>
    <div v-if="!store.contact">
      <div class="deck deck--grey pa-1">
        {{t('MessageNoContact')}}
      </div>
    </div>
    <div v-if="store.contact" class="deck deck--grey py-3 px-4">
      <section>
        <h2 v-html="store.contact.form.title"></h2>
        <p>&nbsp;</p>
        <p v-if="store.insuranceQues">{{store.company.name}}, {{store.company.address}}, CVR: {{store.company.cvr}}</p>
        <p>&nbsp;</p>
        <div v-html="store.contact.form.markup"></div>
        <ul v-if="store.insuranceQues">
          <li v-for="(selectedInsurance, key) in selectedInsurances" :key="key">
          {{selectedInsurance.insurance}}
            <ul v-if="selectedInsurance.subInsurance ">
              <li v-for="(selectedSubInsurance, key) in selectedInsurance.subInsurance" :key="key">{{selectedSubInsurance}}</li>
            </ul>
          </li>
          <li v-if="this.store.checkExtraInsurance">{{this.store.otherInsurances}}</li>
        </ul>
        <p v-if="store.insuranceQues">&nbsp;</p>
        <div v-if="store.contact.form.description" v-html="store.contact.form.description"></div>
        <p v-if="store.insuranceQues">&nbsp;</p>
        <div v-if="store.contact.form.fields_healine" v-html="store.contact.form.fields_healine"></div>
        <div class="grid">
          <div class="grid__col grid__col--8">
            <div class="form">
              <div
                v-for="field in store.contact.form.fields"
                :key="field.name"
                >
                <div
                  v-if="field.type=='checkbox'"
                  class="form__field form__field--checkbox"
                  >
                  <div v-if="field.field_prefix"><h6>{{field.field_prefix}}
                    <span v-if="store.insuranceQues && field.infoHeader" :class="field.name" @click="showModalWindow(field.infoHeader)"><Icon name="info" id="info" ></Icon></span></h6>
                  </div>
                  <input
                    class="form__item"
                    :class="field.class"
                    :id="'field-'+field.name"
                    v-model="field.value"
                    :type="field.type">
                  <label
                    :for="'field-'+field.name"
                    class="form__label"
                    >
                    <span class="form__label__text">{{field.label}}
                      <span v-if="store.insuranceQues && field.infoText" :class="field.name" @click="showModalWindow(field.infoText)"><Icon name="info" id="info" ></Icon></span>
                    </span>
                    <div class="contact-info-content" v-if="field.field_suffix" v-html="field.field_suffix"></div>
                  </label>
                </div>
                <div
                  v-else-if="field.type=='radio'"
                  class="form__field form__field--radio"
                  >
                  <div v-if="field.field_prefix">
                    <span v-html="field.field_prefix"></span>
                    <span v-if="field.required === 'yes'" class="required">&nbsp;*</span>
                  </div>
                  <input
                    class="form__item"
                    :class="field.class"
                    :id="'field-'+field.id"
                    :name="field.name"
                    :type="field.type"
                    :value="field.label"
                    @change="updateRadio(field.id)">
                  <label
                    :for="'field-'+field.id"
                    class="form__label"
                    >
                    <span class="form__label__text">{{field.label}}
                      <span v-if="store.insuranceQues && field.infoText" :class="field.name" @click="showModalWindow(field.infoText)"><Icon name="info" id="info" ></Icon></span>
                    </span>
                    <div class="contact-info-content" v-if="field.field_suffix" v-html="field.field_suffix"></div>
                  </label>
                </div>
                <div
                  v-else
                  class="form__field"
                  :class="['form__field--'+field.type]"
                  >
                  <div v-if="field.field_prefix" v-html="field.field_prefix"></div>
                  <label
                    :for="'field-'+field.name"
                    class="form__label"
                    >
                    <span class="form__label__text">{{field.label}}</span>
                    <span v-if="field.required === 'yes'" class="required">&nbsp;*</span>
                  </label>
                  <input
                    class="form__item"
                    :class="field.class"
                    :id="'field-'+field.name"
                    v-model.trim="field.value"
                    :type="field.type"
                    @blur="field.name === 'email' ? field.value = removeSpace(field.value) : null">
                  <div v-show="errors.length && errors.includes(field.error_msg)" class="form_error">{{field.error_msg}}</div>
                  <div class="contact-info-content" v-if="field.field_suffix" v-html="field.field_suffix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__col mobile-hide">
            <div class="form__label form__label-alignment-hack" role="presentation">&nbsp;</div>
            <aside class="rich-text pa-2 c--grey-4">
              <h4>{{t('ContactInfoInfoBoxHeadline')}}</h4>
              <div v-html="t('ContactInfoInfoBoxContentHtml')">
              </div>
            </aside>
          </div>
        </div>
        <div class="form__field" v-if="store.contact.buttons">
          <div v-if="store.contact.buttons[0].field_prefix" v-html="store.contact.buttons[0].field_prefix"></div>
          <button v-if="!store.insuranceQues"
            class="button button--primary"
            :class="[store.contact.buttons[0].class, {'is-loading': isLoading, 'is-disabled': !isValid}]"
            :disabled="!isValid"
            :data-tealium="store.contact.buttons[0]['data-tealium']"
            @click="doSubmit">
            <span>
              {{store.contact.buttons[0].label}}
            </span>
          </button>
          <button v-if="store.insuranceQues"
            class="button button--primary"
            :class="[store.contact.buttons[0].class, {'is-loading': isLoading, 'is-disabled': !isValidExpandOptions && requestSent}]"
            :disabled="!isValidExpandOptions"
            :data-tealium="store.contact.buttons[0]['data-tealium']"
            @click="doSubmitGB">
            <span>
              {{store.contact.buttons[0].label}}
            </span>
          </button>
        </div>
      </section>
    </div>
    <div class="form__field">
      <button v-if="store.insuranceQues"
        class="button button--secondary"
        @click="goBackInsurance"
        >
        <span>
          {{t('InsurancesButtonBack')}}
        </span>
      </button>
    </div>
    <modal :active="showModal" @close="showModal = false">
      <p v-html="modelContent">{{modelContent}}</p>
    </modal>
  </div>
</template>

<script>
import t from './../../../mixins/t.js'
import Modal from '@/components/common/Modal'
import Icon from '@/components/common/Icon'

export default {
  name: 'ContactInfo',
  data () {
    return {
      store: this.$parent.store,
      isLoading: false,
      dataValid: true,
      requestSent: true,
      value: '',
      name: '',
      radioSelected: false,
      modelContent: '',
      errors: [],
      fields: this.$parent.store.contact.form.fields,
      showModal: false,
      showModelContR1: false,
      showModelContR2: false
    }
  },
  mixins: [t],
  components: {
    Icon,
    Modal
  },
  computed: {
    selectedInsurances: function () {
      let values = this.transformPostForm(
        this.store.insurances,
        this.store.optionalInsurances)
      return values
    },
    'isValid' () {
      return !this.store.contact.form.fields.some(field => {
        return field.value === ''
      })
    },
    'isValidExpandOptions' () {
      return !this.store.contact.form.fields.some(field => {
        if (field.type === 'radio') {
          return this.radioSelected === false
        } else {
          return field.value === '' || field.value === false
        }
      })
    }
  },
  created () {
    let appCommercialGuide = document.getElementById('appCommercialGuide')
    if (appCommercialGuide) {
      appCommercialGuide.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'})
    }
    if (!this.store.insurances) {
      console.log('Insurances missing - begin again')
      this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(0) } })
    } else if (!this.store.contact) {
      console.log('Contact missing - begin again')
      this.$router.push({ name: 'Questions', params: { cvr: this.store.cvr, step: String(0) } })
    }
  },
  methods: {
    updateRadio: function (id) {
      let fieldsWithRadio = this.fields.filter(field => {
        if (field.type === 'radio') {
          return field
        }
      })
      if (fieldsWithRadio) {
        for (let i = 0; i < fieldsWithRadio.length; i++) {
          if (fieldsWithRadio[i].id === id) {
            fieldsWithRadio[i].value = true
            this.radioSelected = true
          } else {
            fieldsWithRadio[i].value = false
          }
        }
      }
    },
    removeSpace: function (value) {
      if (/\s/g.test(value)) {
        return value.replace(/\s/g, '')
      } else {
        return value
      }
    },
    validData: function (value, name) {
      if (name === 'name') {
        var namere = /[a-zA-Z]+ [a-zA-Z ]+/
        if (namere.test(value) && value.length <= 100) {
          return true
        } else {
          return false
        }
      }
      if (name === 'email') {
        var emailre = /(.+)@(.+){1,}\.(.+){2,}/
        if (emailre.test(value) && value.length <= 200) {
          return true
        } else {
          return false
        }
      }
      if (name === 'phone') {
        var phonere = /^[0-9+()-\s]*$/
        if (phonere.test(value) && value.length <= 20) {
          return true
        } else {
          return false
        }
      }
      if (name === 'comment') {
        if (value.length > 100) {
          return false
        } else {
          return true
        }
      }
    },
    validate: function () {
      this.dataValid = true
      this.errors = []
      for (let i = 0; i < this.fields.length; i++) {
        if (this.validData(this.fields[i].value, this.fields[i].name) === false) {
          this.errors.push(this.fields[i].error_msg)
          this.dataValid = false
        }
      }
    },
    doSubmit () {
      this.isLoading = true
      this.$bus.$emit('app_submitForm')
    },
    doSubmitGB () {
      if (this.requestSent) {
        this.validate()
        if (this.dataValid) {
          this.isLoading = true
          this.requestSent = false
          this.$bus.$emit('app_submitForm')
        }
      }
    },
    transformPostForm (insurances, optionalInsurances) {
      let data = this.transformInsurances([...insurances, ...optionalInsurances], true)
      return data
    },
    transformInsurances (insurances, value) {
      let chosenInsurances = insurances.filter(insurance => {
        return insurance.selected === value
      })
      let values = chosenInsurances.map(insurance => {
        if (insurance.subInsurances) {
          let subInsurances = insurance.subInsurances.filter(subInsurance => { return subInsurance.selected === value })
          let val = {}
          val.subInsurance = []
          val.insurance = insurance.title
          for (let i = 0; i < subInsurances.length; i++) {
            val.subInsurance[i] = subInsurances[i].title
          }
          return val
        } else {
          return { insurance: insurance.title }
        }
      })
      return values
    },
    goBackInsurance () {
      window.history.go(-1)
    },
    showModalWindow (infoTxt) {
      this.modelContent = infoTxt
      this.showModal = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media only screen and (max-width: 768px) {
    /* Use the whole width for form input in mobile view */
    .grid__col.grid__col--8 {
      flex: 100%;
    }
  }
  .svg-icon.info {
    width: 1.25rem;
    height: 2.25rem;
  }
  ol, ul {
    list-style-position: inside;
    list-style-type: disc;
  }
  /deep/ h6 {
    font-weight: bold;
  }
  .form_error {
    color: #d63200;
  }
  .input_error {
    border: 0.063rem solid #d63200;
  }
  .required {
    color: red;
  }
  ul > li > ul {
    list-style-type: circle !important;
    margin-left: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contactInfo/ContactInfo.vue